export function Uint8ToString(buffer) {
  if (!buffer) {
    return '';
  }
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCodePoint(bytes[i]);
  }
  return window.btoa(binary);
}